import script from "./CreateUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateUser.vue?vue&type=script&setup=true&lang=ts"

import "./CreateUser.vue?vue&type=style&index=0&id=d3458cd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3458cd6"]])

export default __exports__